import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import articleImg1 from "../assets/img/PraxisMendeKaupischEpikurLauchhammer.webp";
import articleImg2 from "../assets/img/MariaSchwabKinderaerztinHerzberg1.webp";
import articleImg3 from "../assets/img/DrDagmarBlenckeKoethen2.webp";
import articleImg4 from "../assets/img/HajiAhmadianHnoFalkenberg1.webp";
import articleImg5 from "../assets/img/Mannschaftsfoto.webp";
import articleImg5_wide from "../assets/img/Mannschaftsfoto_wide.webp";
import articleImg6 from "../assets/img/HalsNasenOhrenPraxisEpikurFalkenberg2.webp";

function News() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  const isMobile = useMediaQuery({ query: "(max-width: 30em)" });

  const handleArticleExtend = (e) => {
    if (isMobile) {
      handleMobileArticle(e);
    } else {
      handleDesktopArticle(e);
    }
  };

  const handleDesktopArticle = (e) => {
    var _preview = e.target.parentNode.children[1].children[0].children[1];
    var _article1 = e.target.parentNode.children[1].children[0].children[2];
    var _article2 = e.target.parentNode.children[2];
    var extenderText = e.target;
    var _previewDataType = _preview.getAttribute("data-type");

    if (_previewDataType === null) {
      _preview.setAttribute("data-type", "hidden");
      _article1.removeAttribute("data-type");
      _article2.removeAttribute("data-type");
      extenderText.innerHTML = "Einklappen";
    } else if (_previewDataType === "hidden") {
      _article1.setAttribute("data-type", "hidden");
      _article2.setAttribute("data-type", "hidden");
      _preview.removeAttribute("data-type");
      extenderText.innerHTML = "Mehr erfahren";
    }
    return;
  };

  const handleMobileArticle = (e) => {
    var _preview = e.target.parentNode.children[3];
    var _article = e.target.parentNode.children[4];
    var extenderText = e.target;
    var _previewDataType = _preview.getAttribute("data-type");

    if (_previewDataType === null) {
      _preview.setAttribute("data-type", "hidden");
      _article.removeAttribute("data-type");
      extenderText.innerHTML = "Einklappen";
    } else if (_previewDataType === "hidden") {
      _article.setAttribute("data-type", "hidden");
      _preview.removeAttribute("data-type");
      extenderText.innerHTML = "Mehr erfahren";
    }
    return;
  };

  return (
    <section>
      <div className="news-wrapper padding-inline">
        <div className="news-header">Aktuelles</div>
        <div className="news-list">
          <div className="news-article">
            <div className="news-article-header">
              Neustart zum Wohle der Patienten
            </div>
            {isMobile ? (
              <>
                <img
                  className="news-article-img"
                  src={articleImg6}
                  alt="news-article-img"></img>
                <div className="news-article-sub-header">
                  Mit Luei Charanek ist bei Epikur nun ein zweiter HNO-Arzt
                  tätig
                </div>
                <div className="news-article-preview">
                  <p>
                    Falkenberg. Bei all den öffentlichen Debatten um die
                    Schwierigkeiten in der Gesundheitsvorsorge ist das doch
                    einmal eine wahrlich gute Nachricht. Dank maßgeblicher
                    Zuarbeit der Schrader Beratung kann die Schlagzahl der
                    Praxis für Hals-Nasen-Ohrenheilkunde (HNO) im MVZ Epikur in
                    Falkenberg (E.) fortan ...
                  </p>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Falkenberg. Bei all den öffentlichen Debatten um die
                    Schwierigkeiten in der Gesundheitsvorsorge ist das doch
                    einmal eine wahrlich gute Nachricht. Dank maßgeblicher
                    Zuarbeit der Schrader Beratung kann die Schlagzahl der
                    Praxis für Hals-Nasen-Ohrenheilkunde (HNO) im MVZ Epikur in
                    Falkenberg (E.) fortan verdoppelt werden. Neben dr. med.
                    Haji Ahmadian, der bereits seit letztem Jahr in Falkenberg
                    tätig ist, nahm Anfang April an gleicher Stelle auch Luei
                    Charanek seine Arbeit auf. Beide erfahrenen HNO-Fachärzte
                    agieren eigenständig und werden dabei von einem
                    Schwestern-Team unterstützt.
                  </p>
                  <br />
                  <p>
                    Der Wunsch nach beruflicher Veränderung bewog Luei Charanek,
                    von seiner bisherigen Praxis in Herzberg nach Falkenberg zu
                    wechseln. “Bei Epikur sehe ich die größeren Möglichkeiten,
                    mich beruflich weiter zu entwickeln und als Arzt zu
                    verwirklichen”, begründete er den Wechsel. Denn neben der
                    klassischen HNO-Sprechstunde haben sowohl dr. med. Haji
                    Ahmadian als auch Luei Charanek bei Epikur die Chance, ihre
                    Patienten einmal wöchentlich zu operieren. “Alles, was im
                    ambulanten Bereich möglich ist”, verdeutlich Charanek.
                    Angesichts des Mangels an Fachärzten, ist das Einzugsgebiet
                    beider Mediziner groß. ”Es reicht von Senftenberg bis
                    Wittenberg, schließt aber auch Torgau, Lauchammer und Luckau
                    und natürlich den gesamten Elbe-Elster-Kreis mit ein”,
                    ergänzt Ahmadian. Folgerichtig zeichnet sich schon jetzt in
                    beiden Praxen ein großer Zuspruch ab.
                  </p>
                  <br />
                  <p>
                    Telefonische Terminvereinbarungen sind unter der Nummer 035
                    341 477 240 möglich.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            ) : (
              <>
                <div className="news-article-divider">
                  <div className="news-article-content-wrapper">
                    <div className="news-article-sub-header">
                      Mit Luei Charanek ist bei Epikur nun ein zweiter HNO-Arzt
                      tätig
                    </div>
                    <div className="news-article-preview">
                      <p>
                        Falkenberg. Bei all den öffentlichen Debatten um die
                        Schwierigkeiten in der Gesundheitsvorsorge ist das doch
                        einmal eine wahrlich gute Nachricht. Dank maßgeblicher
                        Zuarbeit der Schrader Beratung kann die Schlagzahl der
                        Praxis für Hals-Nasen-Ohrenheilkunde (HNO) im MVZ Epikur
                        in Falkenberg (E.) fortan verdoppelt werden. Neben dr.
                        med. Haji Ahmadian, der bereits seit letztem Jahr in
                        Falkenberg tätig ist, nahm Anfang April an gleicher
                        Stelle auch Luei Charanek seine Arbeit auf. Beide
                        erfahrenen HNO-Fachärzte agieren eigenständig und werden
                        dabei von einem Schwestern-Team unterstützt.
                      </p>
                      <br />
                      <p>
                        Der Wunsch nach beruflicher Veränderung bewog Luei
                        Charanek, von seiner bisherigen Praxis in Herzberg nach
                        Falkenberg zu wechseln. “Bei Epikur sehe ich die
                        größeren Möglichkeiten, mich beruflich weiter zu
                        entwickeln und als Arzt zu verwirklichen”, begründete er
                        den Wechsel. Denn neben der klassischen HNO-Sprechstunde
                        haben sowohl dr. med. Haji Ahmadian als auch Luei
                        Charanek bei Epikur die Chance ...
                      </p>
                    </div>
                    <div className="news-article-content" data-type="hidden">
                      <p>
                        Falkenberg. Bei all den öffentlichen Debatten um die
                        Schwierigkeiten in der Gesundheitsvorsorge ist das doch
                        einmal eine wahrlich gute Nachricht. Dank maßgeblicher
                        Zuarbeit der Schrader Beratung kann die Schlagzahl der
                        Praxis für Hals-Nasen-Ohrenheilkunde (HNO) im MVZ Epikur
                        in Falkenberg (E.) fortan verdoppelt werden. Neben dr.
                        med. Haji Ahmadian, der bereits seit letztem Jahr in
                        Falkenberg tätig ist, nahm Anfang April an gleicher
                        Stelle auch Luei Charanek seine Arbeit auf. Beide
                        erfahrenen HNO-Fachärzte agieren eigenständig und werden
                        dabei von einem Schwestern-Team unterstützt.
                      </p>
                      <br />
                      <p>
                        Der Wunsch nach beruflicher Veränderung bewog Luei
                        Charanek, von seiner bisherigen Praxis in Herzberg nach
                        Falkenberg zu wechseln. “Bei Epikur sehe ich die
                        größeren Möglichkeiten, mich beruflich weiter zu
                        entwickeln und als Arzt zu verwirklichen”, begründete er
                        den Wechsel. Denn neben der klassischen HNO-Sprechstunde
                        haben sowohl dr. med. Haji Ahmadian als auch Luei
                        Charanek bei Epikur die Chance, ihre Patienten einmal
                        wöchentlich zu operieren. “Alles, was im ambulanten
                        Bereich möglich ist”, verdeutlich Charanek. Angesichts
                        des Mangels an Fachärzten, ist das Einzugsgebiet beider
                        Mediziner groß. ”Es reicht von Senftenberg bis
                        Wittenberg, schließt aber auch Torgau, Lauchammer und
                        Luckau und natürlich den gesamten Elbe-Elster-Kreis mit
                        ein”, ergänzt Ahmadian. Folgerichtig zeichnet sich schon
                        jetzt in beiden Praxen ein großer Zuspruch ab.
                      </p>
                      <br />
                      <p>
                        Telefonische Terminvereinbarungen sind unter der Nummer
                        035 341 477 240 möglich.
                      </p>
                    </div>
                    <div className="news-article-author">
                      Author: Sven Gückel
                    </div>
                  </div>
                  <img
                    className="news-article-img"
                    src={articleImg6}
                    alt="news-article-img"></img>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            )}
          </div>

          <div className="news-article">
            <div className="news-article-header">
              Die erste Errungenschaft in den neuen Trikots
            </div>
            {isMobile ? (
              <>
                <img
                  className="news-article-img"
                  src={articleImg5}
                  alt="news-article-img"></img>
                <div className="news-article-preview">
                  <p>
                    Die mD-Jugend des BSV Grün-Weiß Finsterwalde e. V.
                    präsentierte ihre neuen Trikots erstmals in den letzten
                    beiden Spielen. Das Team hat beide Spiele gewonnen und ist
                    weiterhin Tabellenführer...
                  </p>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Die mD-Jugend des BSV Grün-Weiß Finsterwalde e. V.
                    präsentierte ihre neuen Trikots erstmals in den letzten
                    beiden Spielen. Das Team hat beide Spiele gewonnen und ist
                    weiterhin Tabellenführer.
                  </p>
                  <br />
                  <p>
                    Sowohl die Spieler als auch das Trainerteam äußerten sich
                    äußerst zufrieden über die neuen, ansprechenden Trikots. Sie
                    bedankten sich noch einmal ausdrücklich bei Herrn Schrader
                    und Frau Bräutigam für ihre wertvolle Unterstützung.
                  </p>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            ) : (
              <>
                <div
                  className="news-article-divider"
                  style={{ display: "flex", marginBottom: "1.5rem" }}>
                  <div className="news-article-content-wrapper">
                    <div className="news-article-preview">
                      <p>
                        Die mD-Jugend des BSV Grün-Weiß Finsterwalde e. V.
                        präsentierte ihre neuen Trikots erstmals in den letzten
                        beiden Spielen. Das Team hat beide Spiele gewonnen und
                        ist weiterhin Tabellenführer.
                      </p>
                      <br />
                      <p>
                        Sowohl die Spieler als auch das Trainerteam äußerten
                        sich äußerst zufrieden über die neuen, ansprechenden
                        Trikots. Sie bedankten sich noch einmal ausdrücklich bei
                        Herrn Schrader und Frau Bräutigam für ihre wertvolle
                        Unterstützung.
                      </p>
                    </div>
                  </div>
                </div>
                <img
                  className="news-article-img"
                  style={{ width: "100%" }}
                  src={articleImg5_wide}
                  alt="news-article-img"></img>
              </>
            )}
          </div>

          <div className="news-article">
            <div className="news-article-header">
              Gelungener Wechsel und Neustart
            </div>
            {isMobile ? (
              <>
                <img
                  className="news-article-img"
                  src={articleImg1}
                  alt="news-article-img"></img>
                <div className="news-article-sub-header">
                  Rebecca Kaupisch übernimmt Epikur-Praxis von Dr. med. Marion
                  Mende
                </div>
                <div className="news-article-preview">
                  <p>
                    Lauchhammer. Länger als geplant, doch so lange, wie sie es
                    ihren Patienten zugesichert hatte, war Dr. med. Marion Mende
                    als Hausärztin in Lauchhammer tätig. Nun, sagt die
                    73-jährige Hausärztin, sei nach fast 48 Dienstjahren ein
                    guter Zeitpunkt gekommen, den weißen Kittel auszuziehen.
                    Einen perfekten Anlass für diesen Schritt bietet ihr Rebecca
                    Kaupisch (39), die ...
                  </p>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Lauchhammer. Länger als geplant, doch so lange, wie sie es
                    ihren Patienten zugesichert hatte, war Dr. med. Marion Mende
                    als Hausärztin in Lauchhammer tätig. Nun, sagt die
                    73-jährige Hausärztin, sei nach fast 48 Dienstjahren ein
                    guter Zeitpunkt gekommen, den weißen Kittel auszuziehen.
                    Einen perfekten Anlass für diesen Schritt bietet ihr Rebecca
                    Kaupisch (39), die mit Beginn des Jahres 2024 die von Dr.
                    Mende geführte Praxis der MVZ Epikur GmbH samt der vier
                    Praxisschwestern übernimmt. Auch die Kassenärztliche
                    Vereinigung hat dem Wechsel bereits zugestimmt.
                  </p>
                  <br />
                  <p>
                    Die Bekanntschaft beider Frauen währt bereits acht Jahre.
                    Schon damals, 2015, war es die Schrader-Beratung aus
                    Finsterwalde, die den Kontakt vermittelte. Und auch jetzt,
                    da Rebecca Kaupisch nach dem Studium in Greifswald sowie
                    medizinischen Lehrjahren in Würzburg und Senftenberg ihre
                    Facharztprüfung zur Internistin erfolgreich bestand und ihr
                    Können am Klinikum Finsterwalde bewies, war es Uwe Schrader,
                    der die erfolgreiche Praxisnachfolge auf den Weg brachte.
                  </p>
                  <br />
                  <p>
                    In den vergangenen fünf Jahren gehörte Rebecca Kaupisch dem
                    Team des Elbe-Elster-Klinikum an. Dessen aktuelle
                    Entwicklung, sagt sie, habe sie aber bestärkt, in die
                    ambulante Patientenversorgung zu wechseln. “Mir ist es
                    wichtig, zu meinen Patienten einen engen und längjährigen
                    Kontakt zu pflegen, was im Klinikbetrieb kaum möglich ist.
                    Darüber hinaus habe ich eine Zusatzqualifikation im Bereich
                    der Diabetologie absolviert. Ein Bereich, der mir sehr am
                    Herzen liegt. Die Versorgung der betroffenen Patienten
                    findet fast ausschließlich in den Ambulanzen statt”, betont
                    die junge Frau, die mit ihrer Familie in Doberlug-Kirchhain
                    lebt. Als einen Glücksfall erachtet es Kaupisch, dass auch
                    Dr. Mende als Diabetologin arbeitete, wodurch die modernen
                    Praxisräume in der Bockwitzer Straße 91 für diese Arbeit
                    beste Strukturen bereit hielten.
                  </p>
                  <br />
                  <p>
                    Dr. Marion Mende wird sich am 21. Dezember 2023 letztmalig
                    ihrer Patienten annehmen. “Ich räume meinen Platz aber ohne
                    Wehmut und freue mich auf den Lebensabschnitt, der nun vor
                    mir liegt”, betont sie. Ihre Patienten habe sie bereits
                    frühzeitig darüber informiert, dass deren medizinische
                    Versorgung langfristig sichergestellt sei. “Zu Frau Kaupisch
                    und ihren Befähigungen als Ärztin habe ich vollstes
                    Vertrauen und wünsche mir daher, dass meine Patienten sich
                    auch ihr anvertrauen und die Treue halten”, fügt sie an.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            ) : (
              <>
                <div className="news-article-divider">
                  <div className="news-article-content-wrapper">
                    <div className="news-article-sub-header">
                      Rebecca Kaupisch übernimmt Epikur-Praxis von Dr. med.
                      Marion Mende
                    </div>
                    <div className="news-article-preview">
                      <p>
                        Lauchhammer. Länger als geplant, doch so lange, wie sie
                        es ihren Patienten zugesichert hatte, war Dr. med.
                        Marion Mende als Hausärztin in Lauchhammer tätig. Nun,
                        sagt die 73-jährige Hausärztin, sei nach fast 48
                        Dienstjahren ein guter Zeitpunkt gekommen, den weißen
                        Kittel auszuziehen. Einen perfekten Anlass für diesen
                        Schritt bietet ihr Rebecca Kaupisch (39), die mit Beginn
                        des Jahres 2024 die von Dr. Mende geführte Praxis der
                        MVZ Epikur GmbH samt der vier Praxisschwestern
                        übernimmt. Auch die Kassenärztliche Vereinigung hat dem
                        Wechsel bereits zugestimmt.
                      </p>
                      <br />
                      <p>
                        Die Bekanntschaft beider Frauen währt bereits acht
                        Jahre. Schon damals, 2015, war es die Schrader-Beratung
                        aus Finsterwalde, die den Kontakt vermittelte. Und auch
                        jetzt, da Rebecca Kaupisch nach dem Studium in
                        Greifswald sowie medizinischen Lehrjahren in Würzburg
                        und Senftenberg ihre Facharztprüfung zur Internistin
                        erfolgreich bestand und ihr Können am Klinikum
                        Finsterwalde bewies, war es Uwe Schrader, der ...
                      </p>
                    </div>
                    <div className="news-article-content" data-type="hidden">
                      <p>
                        Lauchhammer. Länger als geplant, doch so lange, wie sie
                        es ihren Patienten zugesichert hatte, war Dr. med.
                        Marion Mende als Hausärztin in Lauchhammer tätig. Nun,
                        sagt die 73-jährige Hausärztin, sei nach fast 48
                        Dienstjahren ein guter Zeitpunkt gekommen, den weißen
                        Kittel auszuziehen. Einen perfekten Anlass für diesen
                        Schritt bietet ihr Rebecca Kaupisch (39), die mit Beginn
                        des Jahres 2024 die von Dr. Mende geführte Praxis der
                        MVZ Epikur GmbH samt der vier Praxisschwestern
                        übernimmt. Auch die Kassenärztliche Vereinigung hat dem
                        Wechsel bereits zugestimmt.
                      </p>
                      <br />
                      <p>
                        Die Bekanntschaft beider Frauen währt bereits acht
                        Jahre. Schon damals, 2015, war es die Schrader-Beratung
                        aus Finsterwalde, die den Kontakt vermittelte. Und auch
                        jetzt, da Rebecca Kaupisch nach dem Studium in
                        Greifswald sowie medizinischen Lehrjahren in Würzburg
                        und Senftenberg ihre Facharztprüfung zur Internistin
                        erfolgreich bestand und ihr Können am Klinikum
                        Finsterwalde bewies, war es Uwe Schrader, der die
                        erfolgreiche Praxisnachfolge auf den Weg brachte.
                      </p>
                    </div>
                  </div>
                  <img
                    className="news-article-img"
                    src={articleImg1}
                    alt="news-article-img"></img>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    In den vergangenen fünf Jahren gehörte Rebecca Kaupisch dem
                    Team des Elbe-Elster-Klinikum an. Dessen aktuelle
                    Entwicklung, sagt sie, habe sie aber bestärkt, in die
                    ambulante Patientenversorgung zu wechseln. “Mir ist es
                    wichtig, zu meinen Patienten einen engen und längjährigen
                    Kontakt zu pflegen, was im Klinikbetrieb kaum möglich ist.
                    Darüber hinaus habe ich eine Zusatzqualifikation im Bereich
                    der Diabetologie absolviert. Ein Bereich, der mir sehr am
                    Herzen liegt. Die Versorgung der betroffenen Patienten
                    findet fast ausschließlich in den Ambulanzen statt”, betont
                    die junge Frau, die mit ihrer Familie in Doberlug-Kirchhain
                    lebt. Als einen Glücksfall erachtet es Kaupisch, dass auch
                    Dr. Mende als Diabetologin arbeitete, wodurch die modernen
                    Praxisräume in der Bockwitzer Straße 91 für diese Arbeit
                    beste Strukturen bereit hielten.
                  </p>
                  <br />
                  <p>
                    Dr. Marion Mende wird sich am 21. Dezember 2023 letztmalig
                    ihrer Patienten annehmen. “Ich räume meinen Platz aber ohne
                    Wehmut und freue mich auf den Lebensabschnitt, der nun vor
                    mir liegt”, betont sie. Ihre Patienten habe sie bereits
                    frühzeitig darüber informiert, dass deren medizinische
                    Versorgung langfristig sichergestellt sei. “Zu Frau Kaupisch
                    und ihren Befähigungen als Ärztin habe ich vollstes
                    Vertrauen und wünsche mir daher, dass meine Patienten sich
                    auch ihr anvertrauen und die Treue halten”, fügt sie an.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            )}
          </div>

          <div className="news-article">
            <div className="news-article-header">
              Grippewelle kam mit Ankündigung
            </div>
            {isMobile ? (
              <>
                <img
                  className="news-article-img"
                  src={articleImg2}
                  alt="news-article-img"></img>
                <div className="news-article-sub-header">
                  Dipl.-Med. Maria-Theresia Schwab resümiert über die hohen
                  Krankenstände
                </div>
                <div className="news-article-preview">
                  <p>
                    Herzberg. Seit mehreren Wochen schwingt über Elbe-Elster
                    eine heftige Grippewelle. Nur langsam klingt diese wieder
                    ab. Was sich besonders in den Kindergärten und Schulen der
                    Region ablesen lässt, denn unter Kindern und Jugendlichen
                    grassierte die Erkrankung dieses Mal besonders heftig...
                  </p>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Herzberg. Seit mehreren Wochen schwingt über Elbe-Elster
                    eine heftige Grippewelle. Nur langsam klingt diese wieder
                    ab. Was sich besonders in den Kindergärten und Schulen der
                    Region ablesen lässt, denn unter Kindern und Jugendlichen
                    grassierte die Erkrankung dieses Mal besonders heftig.
                  </p>
                  <br />
                  <p>
                    Dabei fiel die Grippewelle 2025 nicht unangekündigt über das
                    Land her. “Zuerst waren Frankreich und Italien davon
                    betroffen. Man konnte also sehen, was da auf uns zukommt”,
                    erläutert die Herzberger Kinderärztin Dipl.-Med.
                    Maria-Theresia Schwab. Aufgrund ihrer jahrelangen
                    Berufserfahrung warnte sie die Eltern ihrer kleinen
                    Patienten frühzeitig. Leider blieb der gewünschte Erfolg
                    aus. “In den vergangenen Jahren hat die Impfbereitschaft der
                    Menschen abgenommen. Dabei sollten vor allem chronisch
                    Kranke diese Möglichkeit des Vorbeugens wahrnehmen. Das gilt
                    auch für Kinder und Jugendliche, vor allem dann, wenn sie
                    zusätzlich auch mit den Großeltern, einer bei Grippe
                    definierten Risikogruppe, unter einem Dach wohnen”,
                    erläutert die Medizinerin. Die Befürchtungen der Herzberger
                    Kinderärztin teilte zudem das Robert-Koch-Institut (RKI).
                    Hier nimmt man bei den diagnostizierten Grippefällen seit
                    einigen Jahren eine Steigerung wahr. “Die Influenza- und
                    RS-Viren haben in der Saison 2024/25 schon für Todesopfer
                    gesorgt. 80 Prozent von ihnen waren demnach 60 Jahre und
                    älter”, zitiert Schwab eine aktuelle Mitteilung des RKI.
                  </p>
                  <br />
                  <p>
                    Der fachliche Rat von Maria-Theresia Schwab ist bei den
                    Eltern der jüngeren Patienten auch außerhalb der
                    Grippewellen stets gefragt. Nach ihrem Medizinstudium in
                    Leipzig und Greifswald absolvierte sie die
                    Facharztausbildung auf den Kinderstationen der Krankenhäuser
                    in Cottbus und Herzberg. 1991 wagte sie schließlich den
                    Schritt in die Selbständigkeit, 1994 bezog sie die bis heute
                    genutzten Praxisräume in der Torgauer Straße 35a. Im April
                    2023 übergab sie die Einrichtung der MVZ Epikur GmbH und
                    arbeitet dort, auch über ihren Renteneintritt hinaus bis
                    heute als angestellte Ärztin. Mit Hilfe der Schrader
                    Beratung wird es darüber hinaus gelingen, den Praxisbetrieb
                    langfristig fortzusetzen. “Es gibt mehrere Kandidatinnen,
                    die statt meiner hier ab 2026 tätig sein möchten”, blickt
                    Schwab zufrieden voraus. Die Gesundheit der Jüngsten liegt
                    damit auch in den kommenden Jahren in guten Händen.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            ) : (
              <>
                <div className="news-article-divider">
                  <div className="news-article-content-wrapper">
                    <div className="news-article-sub-header">
                      Dipl.-Med. Maria-Theresia Schwab resümiert über die hohen
                      Krankenstände
                    </div>
                    <div className="news-article-preview">
                      <p>
                        Herzberg. Seit mehreren Wochen schwingt über Elbe-Elster
                        eine heftige Grippewelle. Nur langsam klingt diese
                        wieder ab. Was sich besonders in den Kindergärten und
                        Schulen der Region ablesen lässt, denn unter Kindern und
                        Jugendlichen grassierte die Erkrankung dieses Mal
                        besonders heftig.
                      </p>
                      <br />
                      <p>
                        Dabei fiel die Grippewelle 2025 nicht unangekündigt über
                        das Land her. “Zuerst waren Frankreich und Italien davon
                        betroffen. Man konnte also sehen, was da auf uns
                        zukommt”, erläutert die Herzberger Kinderärztin
                        Dipl.-Med. Maria-Theresia Schwab. Aufgrund ihrer
                        jahrelangen Berufserfahrung warnte sie die Eltern ihrer
                        kleinen Patienten frühzeitig. Leider blieb der
                        gewünschte Erfolg aus. “In den vergangenen Jahren hat
                        die Impfbereitschaft der Menschen abgenommen. Dabei
                        sollten vor allem chronisch Kranke diese Möglichkeit des
                        Vorbeugens wahrnehmen. Das gilt ...
                      </p>
                    </div>
                    <div className="news-article-content" data-type="hidden">
                      <p>
                        Herzberg. Seit mehreren Wochen schwingt über Elbe-Elster
                        eine heftige Grippewelle. Nur langsam klingt diese
                        wieder ab. Was sich besonders in den Kindergärten und
                        Schulen der Region ablesen lässt, denn unter Kindern und
                        Jugendlichen grassierte die Erkrankung dieses Mal
                        besonders heftig.
                      </p>
                      <br />
                      <p>
                        Dabei fiel die Grippewelle 2025 nicht unangekündigt über
                        das Land her. “Zuerst waren Frankreich und Italien davon
                        betroffen. Man konnte also sehen, was da auf uns
                        zukommt”, erläutert die Herzberger Kinderärztin
                        Dipl.-Med. Maria-Theresia Schwab. Aufgrund ihrer
                        jahrelangen Berufserfahrung warnte sie die Eltern ihrer
                        kleinen Patienten frühzeitig. Leider blieb der
                        gewünschte Erfolg aus. “In den vergangenen Jahren hat
                        die Impfbereitschaft der Menschen abgenommen. Dabei
                        sollten vor allem chronisch Kranke diese Möglichkeit des
                        Vorbeugens wahrnehmen. Das gilt auch für Kinder und
                        Jugendliche, vor allem dann, wenn sie zusätzlich auch
                        mit den Großeltern, einer bei Grippe definierten
                        Risikogruppe, unter einem Dach wohnen”, erläutert die
                        Medizinerin. Die Befürchtungen der Herzberger
                        Kinderärztin teilte zudem das Robert-Koch-Institut
                        (RKI). Hier nimmt man bei den diagnostizierten
                        Grippefällen seit einigen Jahren eine Steigerung wahr.
                        “Die Influenza- und RS-Viren haben in der Saison 2024/25
                        schon für Todesopfer gesorgt. 80 Prozent von ihnen waren
                        demnach 60 Jahre und älter”, zitiert Schwab eine
                        aktuelle Mitteilung des RKI.
                      </p>
                    </div>
                  </div>
                  <img
                    className="news-article-img"
                    src={articleImg2}
                    alt="news-article-img"></img>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Der fachliche Rat von Maria-Theresia Schwab ist bei den
                    Eltern der jüngeren Patienten auch außerhalb der
                    Grippewellen stets gefragt. Nach ihrem Medizinstudium in
                    Leipzig und Greifswald absolvierte sie die
                    Facharztausbildung auf den Kinderstationen der Krankenhäuser
                    in Cottbus und Herzberg. 1991 wagte sie schließlich den
                    Schritt in die Selbständigkeit, 1994 bezog sie die bis heute
                    genutzten Praxisräume in der Torgauer Straße 35a. Im April
                    2023 übergab sie die Einrichtung der MVZ Epikur GmbH und
                    arbeitet dort, auch über ihren Renteneintritt hinaus bis
                    heute als angestellte Ärztin. Mit Hilfe der Schrader
                    Beratung wird es darüber hinaus gelingen, den Praxisbetrieb
                    langfristig fortzusetzen. “Es gibt mehrere Kandidatinnen,
                    die statt meiner hier ab 2026 tätig sein möchten”, blickt
                    Schwab zufrieden voraus. Die Gesundheit der Jüngsten liegt
                    damit auch in den kommenden Jahren in guten Händen.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            )}
          </div>

          <div className="news-article">
            <div className="news-article-header">
              Praxisübergabe ist gesichert
            </div>
            {isMobile ? (
              <>
                <img
                  className="news-article-img"
                  src={articleImg3}
                  alt="news-article-img"></img>
                <div className="news-article-sub-header">
                  Dr. Dagmar Blencke wechselt in den Ruhestand, Dr. Mohamed
                  Ahmad übernimmt
                </div>
                <div className="news-article-preview">
                  <p>
                    Köthen. Zu ihrer Heimatstadt Köthen pflegte Dr. med. Dagmar
                    Blencke zeitlebens ein enges Verhältnis. Hier wurde die
                    66-Jährige geboren, in der Stadt wuchs sie auf, hier
                    hinterließ sie als niedergelassene Ärztin über vier
                    Jahrzehnte sichtbare Spuren...
                  </p>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Köthen. Zu ihrer Heimatstadt Köthen pflegte Dr. med. Dagmar
                    Blencke zeitlebens ein enges Verhältnis. Hier wurde die
                    66-Jährige geboren, in der Stadt wuchs sie auf, hier
                    hinterließ sie als niedergelassene Ärztin über vier
                    Jahrzehnte sichtbare Spuren.
                  </p>
                  <br />
                  <p>
                    In wenigen Tagen will Dagmar Blencke nun ein neues Kapitel
                    aufschlagen. Am 28. März übergibt sie ihre Praxis für
                    Allgemeinmedizin an Dr. med. Mohamed Ahmad, der gegenwärtig
                    noch als Hausarzt in Guben praktiziert. Lange Zeit hatte Dr.
                    Blencke selbst nach einem Nachfolger gesucht, der ihre
                    Patienten nach ihrem Wechsel in den Ruhestand fortführt.
                    Erst der Kontakt zur Schrader Beratung aus Bad Liebenwerda,
                    einem Unternehmen, das unter anderem auf die Vermittlung von
                    medizinischem Fachpersonal spezialisiert ist, gelang die
                    erfolgreiche Realisierung des Vorhabens. “Ich bin glücklich,
                    dass meine Patienten somit weiterhin versorgt werden”, gibt
                    sich die Medizinerin erleichtert. Wer Dr. Blencke kennt,
                    weiß, dass sie sich zum Wohle ihrer Patienten nie schonte.
                    Mit viel Selbstdisziplin nahm sie sich daher sowohl ihres
                    Studiums in Halle als auch in den Folgejahren ihrer Arbeit
                    als Ärztin an. Der Zuspruch, den sie dafür bekam, war groß.
                    Nicht zuletzt wegen ihres offenen, freundlichen Wesens, aber
                    auch ihrer Eigenschaft, klare Worte dort auszusprechen, wo
                    es nötig ist.
                  </p>
                  <br />
                  <p>
                    Während des gesamten Berufslebens ließ Dagmar Blencke nichts
                    unversucht, sich umfassend und vielschichtig weiterzubilden.
                    Eine besondere Liebe entwickelte sie dabei zur Akupunktur,
                    wofür sie ab 2003 eine mehrjährige Zusatzausbildung
                    absolvierte. “Von Beginn an habe ich in der Akupunktur einen
                    großen Nutzen für meine Patienten erkannt. Langfristig wurde
                    sie sogar zu einem zweiten Standbein meiner Praxis”,
                    erläutert sie. Zum Wohle der Patienten, aber auch zur
                    Verbesserung der Arbeitsbedingungen für sie und ihr
                    Praxisteam, bezog die Ärztin 2004 die noch heute gültigen
                    Praxisräume in der Sebastian-Bach-Straße 22. Diese wird ihr
                    Nachfolger ebenso übernehmen wie das Team, zu dem aktuell
                    drei Mitarbeiterinnen gehören. Für den bekennenden Jazz-Fan
                    Dagmar Blencke beginnt ab April eine Zeit, in der “ich
                    endlich auch einmal spontan leben kann”, freut sie sich.
                    Reisen mit ihrem Mann, Zeit mit der Familie, lesen, ja
                    vielleicht sogar das Singen in einem Chor hat sie sich
                    vorgenommen. Nach einem rastlosen Leben im Dienste anderer
                    Menschen hat sich Dr. Dagmar Blencke diese Freuden durchweg
                    verdient.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            ) : (
              <>
                <div className="news-article-divider">
                  <div className="news-article-content-wrapper">
                    <div className="news-article-sub-header">
                      Dr. Dagmar Blencke wechselt in den Ruhestand, Dr. Mohamed
                      Ahmad übernimmt
                    </div>
                    <div className="news-article-preview">
                      <p>
                        Köthen. Zu ihrer Heimatstadt Köthen pflegte Dr. med.
                        Dagmar Blencke zeitlebens ein enges Verhältnis. Hier
                        wurde die 66-Jährige geboren, in der Stadt wuchs sie
                        auf, hier hinterließ sie als niedergelassene Ärztin über
                        vier Jahrzehnte sichtbare Spuren.
                      </p>
                      <br />
                      <p>
                        In wenigen Tagen will Dagmar Blencke nun ein neues
                        Kapitel aufschlagen. Am 28. März übergibt sie ihre
                        Praxis für Allgemeinmedizin an Dr. med. Mohamed Ahmad,
                        der gegenwärtig noch als Hausarzt in Guben praktiziert.
                        Lange Zeit hatte Dr. Blencke selbst nach einem
                        Nachfolger gesucht, der ihre Patienten nach ihrem
                        Wechsel in den Ruhestand fortführt. Erst der Kontakt zur
                        Schrader Beratung aus Bad Liebenwerda, einem
                        Unternehmen, das unter anderem auf die Vermittlung von
                        medizinischem Fachpersonal spezialisiert ist, gelang die
                        erfolgreiche Realisierung des Vorhabens. “Ich bin
                        glücklich, dass meine Patienten somit weiterhin versorgt
                        werden”, gibt sich die Medizinerin erleichtert. Wer Dr.
                        Blencke kennt, weiß, dass sie sich zum Wohle ihrer
                        Patienten nie schonte. Mit viel Selbstdisziplin nahm ...
                      </p>
                    </div>
                    <div className="news-article-content" data-type="hidden">
                      <p>
                        Köthen. Zu ihrer Heimatstadt Köthen pflegte Dr. med.
                        Dagmar Blencke zeitlebens ein enges Verhältnis. Hier
                        wurde die 66-Jährige geboren, in der Stadt wuchs sie
                        auf, hier hinterließ sie als niedergelassene Ärztin über
                        vier Jahrzehnte sichtbare Spuren.
                      </p>
                      <br />
                      <p>
                        In wenigen Tagen will Dagmar Blencke nun ein neues
                        Kapitel aufschlagen. Am 28. März übergibt sie ihre
                        Praxis für Allgemeinmedizin an Dr. med. Mohamed Ahmad,
                        der gegenwärtig noch als Hausarzt in Guben praktiziert.
                        Lange Zeit hatte Dr. Blencke selbst nach einem
                        Nachfolger gesucht, der ihre Patienten nach ihrem
                        Wechsel in den Ruhestand fortführt. Erst der Kontakt zur
                        Schrader Beratung aus Bad Liebenwerda, einem
                        Unternehmen, das unter anderem auf die Vermittlung von
                        medizinischem Fachpersonal spezialisiert ist, gelang die
                        erfolgreiche Realisierung des Vorhabens. “Ich bin
                        glücklich, dass meine Patienten somit weiterhin versorgt
                        werden”, gibt sich die Medizinerin erleichtert. Wer Dr.
                        Blencke kennt, weiß, dass sie sich zum Wohle ihrer
                        Patienten nie schonte. Mit viel Selbstdisziplin nahm sie
                        sich daher sowohl ihres Studiums in Halle als auch in
                        den Folgejahren ihrer Arbeit als Ärztin an. Der
                        Zuspruch, den sie dafür bekam, war groß. Nicht zuletzt
                        wegen ihres offenen, freundlichen Wesens, aber auch
                        ihrer Eigenschaft, klare Worte dort auszusprechen, wo es
                        nötig ist.
                      </p>
                    </div>
                  </div>
                  <img
                    className="news-article-img"
                    src={articleImg3}
                    alt="news-article-img"></img>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Während des gesamten Berufslebens ließ Dagmar Blencke nichts
                    unversucht, sich umfassend und vielschichtig weiterzubilden.
                    Eine besondere Liebe entwickelte sie dabei zur Akupunktur,
                    wofür sie ab 2003 eine mehrjährige Zusatzausbildung
                    absolvierte. “Von Beginn an habe ich in der Akupunktur einen
                    großen Nutzen für meine Patienten erkannt. Langfristig wurde
                    sie sogar zu einem zweiten Standbein meiner Praxis”,
                    erläutert sie. Zum Wohle der Patienten, aber auch zur
                    Verbesserung der Arbeitsbedingungen für sie und ihr
                    Praxisteam, bezog die Ärztin 2004 die noch heute gültigen
                    Praxisräume in der Sebastian-Bach-Straße 22. Diese wird ihr
                    Nachfolger ebenso übernehmen wie das Team, zu dem aktuell
                    drei Mitarbeiterinnen gehören. Für den bekennenden Jazz-Fan
                    Dagmar Blencke beginnt ab April eine Zeit, in der “ich
                    endlich auch einmal spontan leben kann”, freut sie sich.
                    Reisen mit ihrem Mann, Zeit mit der Familie, lesen, ja
                    vielleicht sogar das Singen in einem Chor hat sie sich
                    vorgenommen. Nach einem rastlosen Leben im Dienste anderer
                    Menschen hat sich Dr. Dagmar Blencke diese Freuden durchweg
                    verdient.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            )}
          </div>

          <div className="news-article">
            <div className="news-article-header">
              Umfassendes Leistungsangebot
            </div>
            {isMobile ? (
              <>
                <img
                  className="news-article-img"
                  src={articleImg4}
                  alt="news-article-img"></img>
                <div className="news-article-sub-header">
                  FA für HNO dr. Haji Ahmadian steht seinen Patienten in
                  Falkenberg zu Diensten
                </div>
                <div className="news-article-preview">
                  <p>
                    Falkenberg. Nicht zuletzt dank des unermüdlichen Wirkens der
                    Schrader Beratung agiert die ambulante medizinische
                    Versorgung des Landkreises Elbe-Elster auf einem hohen
                    Niveau. Seit einigen Wochen können Patienten der Region im
                    Sport- und Gesundheitszentrum Falkenberg nun auch die
                    Dienste des Hals-Nasen-Ohren-Arztes (HNO) dr. med. Haji
                    Ahmadian in Anspruch nehmen. Der aus Armenien stammende
                    Facharzt studierte und arbeitete viele Jahre in...
                  </p>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Falkenberg. Nicht zuletzt dank des unermüdlichen Wirkens der
                    Schrader Beratung agiert die ambulante medizinische
                    Versorgung des Landkreises Elbe-Elster auf einem hohen
                    Niveau. Seit einigen Wochen können Patienten der Region im
                    Sport- und Gesundheitszentrum Falkenberg nun auch die
                    Dienste des Hals-Nasen-Ohren-Arztes (HNO) dr. med. Haji
                    Ahmadian in Anspruch nehmen. Der aus Armenien stammende
                    Facharzt studierte und arbeitete viele Jahre in Ungarn,
                    bevor er 2015 aus familiären Gründen nach Stendal
                    übersiedelte. Dabei entstand auch sein Kontakt zur Schrader
                    Beratung. Uwe Schrader wiederum unterbreitete dem Facharzt
                    das Angebot, als Mitarbeiter des MVZ Epikur zu arbeiten,
                    anfangs in Bad Liebenwerda, nunmehr und langfristig in
                    Falkenberg. Für den Mediziner der Hals-Nasen-Ohrenheilkunde
                    ist das eine ideale Gelegenheit, sein fachliches Können den
                    Patienten in perfekter Umgebung zuteil werden zu lassen. Die
                    neu eingerichtete und hochmoderne Praxis sowie auch der in
                    nur geringer Entfernung zur Praxis befindliche Bahnhof
                    Falkenberg bieten dem Arzt und seinen Patienten ein
                    optimales Wirkungsfeld.
                  </p>
                  <br />
                  <p>
                    Angesichts der nur begrenzten Anzahl von HNO-Praxen in der
                    Region ist der Zuspruch zur Praxis von dr. Ahmadian von
                    Beginn an hoch. Ohne Altersbeschränkung bietet er den bei
                    ihm Hilfe Suchenden ein umfassendes Leistungsspektrum. Dazu
                    gehören neben der Diagnostik und Behandlung von
                    Ohrenkrankheiten wie Paukenröhrchen, Hörsturz, Tinitus oder
                    Fremdkörperentfernung auch Therapien bei Mund- Rachen- und
                    Kehlkopferkrankungen. Zudem nimmt er beispielsweise
                    Behandlungen an der Speicheldrüse oder die Nachsorge von
                    Tumorbehandlungen vor oder führt Hörtests,
                    Kinderhörscreening, Kopfimpulstests sowie Therapie und
                    Psychotherapien bei Schwindel durch. Beratung und Therapie
                    bei Allergien gehören im Weiteren zum keineswegs
                    standardisierten Leistungsangebot der Falkenberger
                    HNO-Praxis. Vollendet wird das Programm darüber hinaus durch
                    ambulante Operationen im Kopf- und Halsbereich, die
                    ebenfalls vor Ort in Falkenberg vorgenommen werden können.
                  </p>
                  <br />
                  <p>
                    Angesichts des bereits erwähnten hohen Zuspruchs der
                    Patienten bietet dr. Ahmadian seit Beginn dieses Jahres in
                    seiner Praxis nach Rücksprache auch eine
                    Samstagssprechstunden an.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            ) : (
              <>
                <div className="news-article-divider">
                  <div className="news-article-content-wrapper">
                    <div className="news-article-sub-header">
                      FA für HNO dr. Haji Ahmadian steht seinen Patienten in
                      Falkenberg zu Diensten
                    </div>
                    <div className="news-article-preview">
                      <p>
                        Falkenberg. Nicht zuletzt dank des unermüdlichen Wirkens
                        der Schrader Beratung agiert die ambulante medizinische
                        Versorgung des Landkreises Elbe-Elster auf einem hohen
                        Niveau. Seit einigen Wochen können Patienten der Region
                        im Sport- und Gesundheitszentrum Falkenberg nun auch die
                        Dienste des Hals-Nasen-Ohren-Arztes (HNO) dr. med. Haji
                        Ahmadian in Anspruch nehmen. Der aus Armenien stammende
                        Facharzt studierte und arbeitete viele Jahre in Ungarn,
                        bevor er 2015 aus familiären Gründen nach Stendal
                        übersiedelte. Dabei entstand auch sein Kontakt zur
                        Schrader Beratung. Uwe Schrader wiederum unterbreitete
                        dem Facharzt das Angebot, als Mitarbeiter des MVZ Epikur
                        zu arbeiten, anfangs in Bad Liebenwerda, nunmehr und
                        langfristig in Falkenberg. Für den Mediziner der
                        Hals-Nasen-Ohrenheilkunde ist das eine ideale
                        Gelegenheit, sein fachliches Können den Patienten in
                        perfekter Umgebung zuteil werden zu lassen. Die neu
                        eingerichtete und hochmoderne Praxis sowie auch der in
                        nur geringer Entfernung zur Praxis befindliche Bahnhof
                        Falkenberg bieten dem Arzt und seinen Patienten ein
                        optimales Wirkungsfeld.
                      </p>
                      <br />
                      <p>
                        Angesichts der nur begrenzten Anzahl von HNO-Praxen in
                        der Region ist der Zuspruch zur Praxis von dr. Ahmadian
                        von Beginn an hoch. Ohne Altersbeschränkung bietet er
                        den bei ihm Hilfe Suchenden ein umfassendes
                        Leistungsspektrum. Dazu gehören...
                      </p>
                    </div>
                    <div className="news-article-content" data-type="hidden">
                      <p>
                        Falkenberg. Nicht zuletzt dank des unermüdlichen Wirkens
                        der Schrader Beratung agiert die ambulante medizinische
                        Versorgung des Landkreises Elbe-Elster auf einem hohen
                        Niveau. Seit einigen Wochen können Patienten der Region
                        im Sport- und Gesundheitszentrum Falkenberg nun auch die
                        Dienste des Hals-Nasen-Ohren-Arztes (HNO) dr. med. Haji
                        Ahmadian in Anspruch nehmen. Der aus Armenien stammende
                        Facharzt studierte und arbeitete viele Jahre in Ungarn,
                        bevor er 2015 aus familiären Gründen nach Stendal
                        übersiedelte. Dabei entstand auch sein Kontakt zur
                        Schrader Beratung. Uwe Schrader wiederum unterbreitete
                        dem Facharzt das Angebot, als Mitarbeiter des MVZ Epikur
                        zu arbeiten, anfangs in Bad Liebenwerda, nunmehr und
                        langfristig in Falkenberg. Für den Mediziner der
                        Hals-Nasen-Ohrenheilkunde ist das eine ideale
                        Gelegenheit, sein fachliches Können den Patienten in
                        perfekter Umgebung zuteil werden zu lassen. Die neu
                        eingerichtete und hochmoderne Praxis sowie auch der in
                        nur geringer Entfernung zur Praxis befindliche Bahnhof
                        Falkenberg bieten dem Arzt und seinen Patienten ein
                        optimales Wirkungsfeld.
                      </p>
                      <br />
                      <p>
                        Angesichts der nur begrenzten Anzahl von HNO-Praxen in
                        der Region ist der Zuspruch zur Praxis von dr. Ahmadian
                        von Beginn an hoch. Ohne Altersbeschränkung bietet er
                        den bei ihm Hilfe Suchenden ein umfassendes
                        Leistungsspektrum. Dazu gehören neben der Diagnostik und
                        Behandlung von Ohrenkrankheiten wie Paukenröhrchen,
                        Hörsturz, Tinitus oder Fremdkörperentfernung auch
                        Therapien bei Mund- Rachen- und Kehlkopferkrankungen.
                        Zudem nimmt er beispielsweise Behandlungen an der
                        Speicheldrüse oder die Nachsorge von Tumorbehandlungen
                        vor oder führt Hörtests, Kinderhörscreening,
                        Kopfimpulstests sowie Therapie und Psychotherapien bei
                        Schwindel durch. Beratung und Therapie bei Allergien
                        gehören im Weiteren zum keineswegs standardisierten
                        Leistungsangebot der Falkenberger HNO-Praxis.
                      </p>
                    </div>
                  </div>
                  <img
                    className="news-article-img"
                    src={articleImg4}
                    alt="news-article-img"></img>
                </div>
                <div className="news-article-content" data-type="hidden">
                  <p>
                    Vollendet wird das Programm darüber hinaus durch ambulante
                    Operationen im Kopf- und Halsbereich, die ebenfalls vor Ort
                    in Falkenberg vorgenommen werden können. Angesichts des
                    bereits erwähnten hohen Zuspruchs der Patienten bietet dr.
                    Ahmadian seit Beginn dieses Jahres in seiner Praxis nach
                    Rücksprache auch eine Samstagssprechstunden an.
                  </p>
                  <div className="news-article-author">Author: Sven Gückel</div>
                </div>
                <div
                  className="btn-article-extender"
                  onClick={(e) => handleArticleExtend(e)}>
                  Mehr erfahren
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default News;
